api = require '../api'

module.exports =

  send: (data) ->
    api.send
      method: 'POST'
      path: '/api/v2/errors'
      payload: data
